import createIcon from '../../createIcon';

/**
 * @component @name DeliveryDining
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgN0MxOSA1LjkgMTguMSA1IDE3IDVIMTRWN0gxN1Y5LjY1TDEzLjUyIDE0SDEwVjlINkMzLjc5IDkgMiAxMC43OSAyIDEzVjE2SDRDNCAxNy42NiA1LjM0IDE5IDcgMTlDOC42NiAxOSAxMCAxNy42NiAxMCAxNkgxNC40OEwxOSAxMC4zNVY3Wk03IDE3QzYuNDUgMTcgNiAxNi41NSA2IDE2SDhDOCAxNi41NSA3LjU1IDE3IDcgMTdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTAgNkg1VjhIMTBWNloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOSAxM0MxNy4zNCAxMyAxNiAxNC4zNCAxNiAxNkMxNiAxNy42NiAxNy4zNCAxOSAxOSAxOUMyMC42NiAxOSAyMiAxNy42NiAyMiAxNkMyMiAxNC4zNCAyMC42NiAxMyAxOSAxM1pNMTkgMTdDMTguNDUgMTcgMTggMTYuNTUgMTggMTZDMTggMTUuNDUgMTguNDUgMTUgMTkgMTVDMTkuNTUgMTUgMjAgMTUuNDUgMjAgMTZDMjAgMTYuNTUgMTkuNTUgMTcgMTkgMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DeliveryDining = createIcon('DeliveryDining', [
  [
    'path',
    {
      d: 'M19 7C19 5.9 18.1 5 17 5H14V7H17V9.65L13.52 14H10V9H6C3.79 9 2 10.79 2 13V16H4C4 17.66 5.34 19 7 19C8.66 19 10 17.66 10 16H14.48L19 10.35V7ZM7 17C6.45 17 6 16.55 6 16H8C8 16.55 7.55 17 7 17Z',
      key: 'nz28l1',
    },
  ],
  ['path', { d: 'M10 6H5V8H10V6Z', key: '1odh9e' }],
  [
    'path',
    {
      d: 'M19 13C17.34 13 16 14.34 16 16C16 17.66 17.34 19 19 19C20.66 19 22 17.66 22 16C22 14.34 20.66 13 19 13ZM19 17C18.45 17 18 16.55 18 16C18 15.45 18.45 15 19 15C19.55 15 20 15.45 20 16C20 16.55 19.55 17 19 17Z',
      key: '1uagvp',
    },
  ],
]);

export default DeliveryDining;
